import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import "@/App.css";
import { AuthProvider } from "@/contexts/AuthContext";
import ProtectedRoute from "@/components/ProtectedRoute";
import Login from "@/pages/Login";
import Dashboard from "@/pages/Dashboard";
import InvoicesList from "@/pages/InvoicesList";
import InvoiceNew from "@/pages/InvoiceNew";
import InvoiceDetail from "@/pages/InvoiceDetail";
import BeneficiamentoProcess from "@/pages/BeneficiamentoProcess";
import PalletLabel from "@/pages/PalletLabel";
import BenefPrecos from "@/pages/BenefPrecos";
import Romaneio from "@/pages/Romaneio";
import RomaneioCustos from "@/pages/RomaneioCustos";
import TerceirosNFsList from "@/pages/TerceirosNFsList";
import TerceirosNFNew from "@/pages/TerceirosNFNew";
import TerceirosPallets from "@/pages/TerceirosPallets";
import TerceirosRetiradas from "@/pages/TerceirosRetiradas";
import TerceirosRetiradaNew from "@/pages/TerceirosRetiradaNew";
import TerceirosRelatorioCliente from "@/pages/TerceirosRelatorioCliente";
import RomaneioTerceiros from "@/pages/RomaneioTerceiros";
import SacariasEstoque from "@/pages/SacariasEstoque";
import Expedicao from "@/pages/Expedicao";
import Suppliers from "@/pages/Suppliers";
import Motoristas from "@/pages/Motoristas";
import Stock from "@/pages/Stock";
import Settings from "@/pages/Settings";
import Clients from "@/pages/Clients";
import ShipmentsList from "@/pages/ShipmentsList";
import ShipmentForm from "@/pages/ShipmentForm";
import ShipmentDetail from "@/pages/ShipmentDetail";
import FinanceOverview from "@/pages/FinanceOverview";
import DriverFreights from "@/pages/DriverFreights";
import { AccountsPayablePage, AccountsReceivablePage } from "@/pages/Accounts";
import Cashflow from "@/pages/Cashflow";
import Funcionarios from "@/pages/Funcionarios";
import Payroll from "@/pages/Payroll";
import Ponto from "@/pages/Ponto";
import Recurring from "@/pages/Recurring";
import Reports from "@/pages/Reports";
import Sacarias from "@/pages/Sacarias";
import { PalletsList, PalletForm, PalletDetail } from "@/pages/Pallets";
import EstoqueConferencia from "@/pages/EstoqueConferencia";
import Rebeneficiamento from "@/pages/Rebeneficiamento";
import AiAssistantWidget from "@/components/AiAssistantWidget";
import CompanySettings from "@/pages/CompanySettings";
import AuditLogs from "@/pages/AuditLogs";
import Faturamento from "@/pages/Faturamento";
import Backup from "@/pages/Backup";
import ModoDemo from "@/pages/ModoDemo";
import Assinatura from "@/pages/Assinatura";
import { PaymentSuccess, PaymentCancel } from "@/pages/Payment";

const PR = ({ children }) => <ProtectedRoute>{children}</ProtectedRoute>;

function App() {
  return (
    <AuthProvider>
      <BrowserRouter>
        <Routes>
          <Route path="/login" element={<Login />} />
          <Route path="/" element={<Navigate to="/dashboard" replace />} />
          <Route path="/dashboard" element={<PR><Dashboard /></PR>} />
          <Route path="/invoices" element={<PR><InvoicesList /></PR>} />
          <Route path="/invoices/new" element={<PR><InvoiceNew /></PR>} />
          <Route path="/invoices/:id/edit" element={<PR><InvoiceNew /></PR>} />
          <Route path="/invoices/:id" element={<PR><InvoiceDetail /></PR>} />
          <Route path="/invoices/:id/beneficiamento" element={<PR><BeneficiamentoProcess /></PR>} />
          <Route path="/invoices/:id/romaneio" element={<PR><Romaneio /></PR>} />
          <Route path="/invoices/:id/romaneio-custos" element={<PR><RomaneioCustos /></PR>} />
          <Route path="/terceiros/nfs" element={<PR><TerceirosNFsList /></PR>} />
          <Route path="/terceiros/nfs/new" element={<PR><TerceirosNFNew /></PR>} />
          <Route path="/terceiros/pallets" element={<PR><TerceirosPallets /></PR>} />
          <Route path="/terceiros/retiradas" element={<PR><TerceirosRetiradas /></PR>} />
          <Route path="/terceiros/retiradas/new" element={<PR><TerceirosRetiradaNew /></PR>} />
          <Route path="/terceiros/relatorio-cliente" element={<PR><TerceirosRelatorioCliente /></PR>} />
          <Route path="/terceiros/nfs/:id/romaneio" element={<PR><RomaneioTerceiros /></PR>} />
          <Route path="/pallet-label/:id" element={<PR><PalletLabel /></PR>} />
          <Route path="/admin/benef-precos" element={<PR><BenefPrecos /></PR>} />
          <Route path="/suppliers" element={<PR><Suppliers /></PR>} />
          <Route path="/motoristas" element={<PR><Motoristas /></PR>} />
          <Route path="/stock" element={<PR><Stock /></PR>} />
          <Route path="/estoque/rebeneficiamento" element={<PR><Rebeneficiamento /></PR>} />
          <Route path="/clients" element={<PR><Clients /></PR>} />
          <Route path="/shipments" element={<PR><ShipmentsList /></PR>} />
          <Route path="/expedicao" element={<PR><Expedicao /></PR>} />
          <Route path="/shipments/new" element={<PR><ShipmentForm /></PR>} />
          <Route path="/shipments/:id" element={<PR><ShipmentDetail /></PR>} />
          <Route path="/shipments/:id/edit" element={<PR><ShipmentForm /></PR>} />
          <Route path="/faturamento" element={<PR><Faturamento /></PR>} />
          <Route path="/finance" element={<PR><FinanceOverview /></PR>} />
          <Route path="/finance/payable" element={<PR><AccountsPayablePage /></PR>} />
          <Route path="/finance/receivable" element={<PR><AccountsReceivablePage /></PR>} />
          <Route path="/finance/fretes" element={<PR><DriverFreights /></PR>} />
          <Route path="/finance/cashflow" element={<PR><Cashflow /></PR>} />
          <Route path="/rh/funcionarios" element={<PR><Funcionarios /></PR>} />
          <Route path="/rh/folha" element={<PR><Payroll /></PR>} />
          <Route path="/rh/ponto" element={<PR><Ponto /></PR>} />
          <Route path="/finance/recurring" element={<PR><Recurring /></PR>} />
          <Route path="/reports" element={<PR><Reports /></PR>} />
          <Route path="/sacarias" element={<PR><Sacarias /></PR>} />
          <Route path="/sacarias/estoque" element={<PR><SacariasEstoque /></PR>} />
          <Route path="/pallets" element={<PR><PalletsList /></PR>} />
          <Route path="/pallets/new" element={<PR><PalletForm /></PR>} />
          <Route path="/pallets/:id" element={<PR><PalletDetail /></PR>} />
          <Route path="/pallets/:id/edit" element={<PR><PalletForm /></PR>} />
          <Route path="/estoque/conferencia" element={<PR><EstoqueConferencia /></PR>} />
          <Route path="/company" element={<PR><CompanySettings /></PR>} />
          <Route path="/audit" element={<PR><AuditLogs /></PR>} />
          <Route path="/backup" element={<PR><Backup /></PR>} />
          <Route path="/modo-demo" element={<PR><ModoDemo /></PR>} />
          <Route path="/assinatura" element={<PR><Assinatura /></PR>} />
          <Route path="/payment/success" element={<PR><PaymentSuccess /></PR>} />
          <Route path="/payment/cancel" element={<PR><PaymentCancel /></PR>} />
          <Route path="/settings" element={<PR><Settings /></PR>} />
          <Route path="*" element={<Navigate to="/dashboard" replace />} />
        </Routes>
        <AiAssistantWidget />
      </BrowserRouter>
    </AuthProvider>
  );
}

export default App;
